<template>
  <div>
    <BaseCard
      :title="localStorage.translations.pages.sales_project['planned_resources-labels']['vid-raboty']"
      class-body="d-grid grid-col-md-1-3 gap-col-8 gap-row-5"
      class-footer="d-grid grid-col-md-1-3 gap-col-8 gap-row-5"
    >
      <div class="d-flex gap-5 fill-height flex-md-column justify-space-between">
        <div class="f14">
          {{ item.work_type.name }}
        </div>
        <ProjectPlannedResourcesWorkTypePeriodModal
          v-if="edit"
          :create="true"
          :projectWorkTypeId="item.id"
          :workTypeId="item.work_type.id"
        />
      </div>
      <div class="d-grid gap-4" :class="edit ? 'mb-md-12' : ''">
        <template v-for="period in mainWorks">
          <v-divider :key="'divider' + period.id" v-if="$vuetify.breakpoint.smAndDown" />
          <ProjectPlannedResourcesWorkTypePeriod
            :key="'main__id_' + period.id"
            :workTypeId="item.work_type.id"
            :item="period"
            :server="true"
            :edit="edit"
          />
        </template>
      </div>
      <template slot="footer" v-if="extraWorks && extraWorks.length">
        <div class="f14">
          {{ localStorage.translations.pages.sales_project['planned_resources-labels']['dopolnitelnye-resursy'] }}
        </div>
        <div class="d-grid gap-4" :class="edit ? 'mr-md-20' : ''">
          <template v-for="period in extraWorks">
            <v-divider :key="'divider' + period.id" v-if="$vuetify.breakpoint.smAndDown" />
            <ProjectPlannedResourcesWorkTypePeriod
              :key="'extra__id_' + period.id"
              :workTypeId="item.work_type.id"
              :item="period"
              :server="true"
            />
          </template>
        </div>
      </template>
    </BaseCard>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import ProjectPlannedResourcesWorkTypePeriod from './ProjectPlannedResourcesWorkTypePeriod'
import ProjectPlannedResourcesWorkTypePeriodModal from './ProjectPlannedResourcesWorkTypePeriodModal'
import BaseCard from "components/base/BaseCard";

export default {
  name: 'ProjectPlannedResourcesWorkType',
  components: {
    BaseCard,
    ProjectPlannedResourcesWorkTypePeriod,
    ProjectPlannedResourcesWorkTypePeriodModal,
  },
  props: ['item', 'itemKey', 'client', 'workTypeList', 'edit'],
  data: () => ({
    valid: false,
  }),
  created() {},
  updated() {},
  watch: {},
  mounted() {},
  computed: {
    ...mapGetters('workClientProject', ['workClientProjectShow']),
    ...mapGetters('workClientProjectsWorkTypePeriod', [
      'workClientProjectsWorkTypePeriodAll_project',
    ]),
    periodList() {
      let periodList = this.workClientProjectsWorkTypePeriodAll_project.filter(
        (i) => i.project_work_type.id === this.item.id,
      )
      let periodListReassembled = []
      for (let i = 0; i < periodList.length; ++i) {
        let employees = periodList[i].employees
        let employeesIdList = employees
          .map((item) => item.id)
          .filter((value, index, self) => self.indexOf(value) === index)
        let data = {
          employees_list: periodList[i].employees,
          employees: employeesIdList,
          start_date: periodList[i].start_date,
          end_date: periodList[i].end_date,
          id: periodList[i].id,
          project_work_type: periodList[i].project_work_type,
          is_extra: periodList[i].is_extra,
        }
        periodListReassembled.push(data)
      }
      return periodListReassembled
    },
    mainWorks() {
      return this.periodList.filter((i) => i.is_extra == 0)
    },
    extraWorks() {
      return this.periodList.filter((i) => i.is_extra == 1)
    },
  },
  methods: {},
}
</script>
